export enum Role {
  SrManager = 'Senior manager',
  UBO = 'UBO',
  CEO = 'CEO',
}
